import './css';
import {createGlobalStyle} from 'styled-components';
import {AntdStyled} from "./antdStyle";
import {AntdV5Styled} from "./antdV5Style";
import {CommonStyled} from "./commonStyle";
import {ReactourStyle} from "./ReactourStyle";
import {PanelFormStyle} from "./panelFormStyle";
import {EditableStyled} from "../components/Editable/style";
import {LockStyleCss} from "../components/Access/common/style";
import {ReadOnlyStyle} from "../components/DataEntry/utils/style";
import {TransactionTransferStyled} from "../components/TransactionTransfer/style";
import {SortableCategoriesStyled} from "../containers/AppPage/StoreSettings/Categories/rearrange.style";
import {UploadWithMenuItemStyled} from '../components/FileUploaderListManager/style';
import {ReportAccountsFormStyled} from "../containers/AppPage/Reports/style";
import {SelectModalStyled} from "../components/TransactionTransfer/TransactionModal/style";
import {LogoStyled} from "../components/Logo/style";
import {SidebarGlobalStyle} from "../containers/Sidebar/sidebar.style";
import {TopbarStyled} from "../containers/Topbar/topbar.style";
import {AuditTrailStyle} from "../containers/AppPage/Reports/AuditTrails/style";
import {AnnouncementStyle} from "../containers/App/Announcement.style";
import {LocationWithBalanceStyled} from '../components/Select/LocationWithBalance/LocationWithBalanceStyled';
import {UomSelectStyled} from '../components/Select/QuantityWithUom/UomSelectStyled';
import {ProductSelectStyled} from '../components/Select/ProductV2/styles/ProductSelectStyled';
import {
    ProductSelectDropdownStyled,
} from '../components/Select/ProductV2/styles/ProductSelect.Dropdown.Styled';
import {StockTransferPopupStyled} from '../components/Quantity/style';
import {FileSelectWrapStyled} from '../components/Files/FileSelect/styles/FileSelectWrapStyled';
import {SubmitFooterStyle} from "../components/SubmitFooter/style";
import {ShoeboxUploadStyled} from '../components/Modal/ShoeboxUpload/style';
import {CustomScrollBarStyle} from '../components/ScrollBar';
import { FormItemWithPlaceholderDropdownStyled } from '../components/Dropdown/Placeholder/style';
import {TableStyled} from "./tableStyle";
import { ContactSelectDropdownStyled } from '../components/Select/Contact/style';
import { KeyboardButtonStyled } from 'bukku/components/GlobalSearch';
import {TopbarNotificationModalStyled} from "../components/Notifications/ModalStyle";
import {TransferredToPopoverStyled} from "../components/TransactionTransfer/Tag/TransferredToInfoPopover";
import { BukkuMessageStyled } from '../components/Message';
import { PopoverAmountTdStyle } from '../components/Table/Common/AmountTd/style';
import { CollapsibleCardCss } from '../components/CollapsibleCard/style';
import { DialCodeInputStyles } from '../components/Input/DialCodeInput';
import {StyledSelectDropdownCss} from "../components/Select/TransactionType";
import { ContactAddressStyle } from '../components/Select/ContactAddress/style';
import { TextAreaExpandIconCSS } from '../components/Editable/TextArea';
import { MandatePopoverCss } from '../containers/AppPage/Contacts/Mandate/components/MandatePopoverTag/MandatePopoverTag.style';
import { BankIntegrationModalCss } from '../components/ListMenu/BankAccount/BankIntegrationModal.style';
import { ProductV2SelectCss } from '../components/Select/ProductV2/styles/style';
import { RoundedBorderGhostCardCss } from '../components/Modal/SubscribeSwitchPlan/components/AddonTogglerList/AddOnToggler/style';
import { DashboardCustomizeDragNDropCss } from '../containers/AppPage/Dashboard2/CustomizeWidgetButton/DragNDropGrid/helper/DashboardCustomizeDragNDropCss';
import { MyInvoisActionModalCss } from '../components/MyInvois/getMyInvoisActionValidateModalPromise';
import { SupportButtonStyled } from '../components/SupportButton/style';

export const GlobalStyles = createGlobalStyle`
  /* Ant Design & Standard */
  ${AntdStyled}
  ${AntdV5Styled}
  ${CommonStyled}

  /* Small Style */
  ${ReactourStyle}
  ${LockStyleCss}
  ${ReadOnlyStyle}
  ${CustomScrollBarStyle}
  
  /* Layout Style */
  ${LogoStyled}
  ${TopbarStyled}
  ${SidebarGlobalStyle}
  
  /* Large Style */
  ${TableStyled}
  ${EditableStyled}
  ${PanelFormStyle}
  ${SubmitFooterStyle}
  
  /* Modal, Popover, Select, Dropdown, Message etc. */
  ${AnnouncementStyle}
  ${SelectModalStyled}
  ${ShoeboxUploadStyled}
  ${UomSelectStyled}
  ${ProductSelectStyled}
  ${ProductSelectDropdownStyled}
  ${ContactSelectDropdownStyled}
  ${StockTransferPopupStyled}
  ${LocationWithBalanceStyled}
  ${TransactionTransferStyled}
  ${UploadWithMenuItemStyled}
  ${BukkuMessageStyled}
  ${ProductV2SelectCss}
  ${SupportButtonStyled}

  /* Specific Use-case */
  ${FileSelectWrapStyled}
  ${ReportAccountsFormStyled}
  ${AuditTrailStyle}
  ${SortableCategoriesStyled}
  ${FormItemWithPlaceholderDropdownStyled}
  ${KeyboardButtonStyled}
  ${TopbarNotificationModalStyled}
  ${TransferredToPopoverStyled}
  ${PopoverAmountTdStyle}
  ${CollapsibleCardCss}
  ${DialCodeInputStyles}
  ${StyledSelectDropdownCss}
  ${ContactAddressStyle}
  ${MandatePopoverCss}
  ${BankIntegrationModalCss}

  ${TextAreaExpandIconCSS}
  ${RoundedBorderGhostCardCss}
  ${DashboardCustomizeDragNDropCss}

  ${MyInvoisActionModalCss}
`;
